import { UserServerActionCreators } from '../actions/UserServerActionCreators';

export const UserInitialiser = {
  initialise: () => {
    const usersNode = document.getElementById('initial-users-data');
    if (usersNode) {
      const initialUsers = JSON.parse(usersNode.textContent);
      Object.keys(initialUsers).forEach((profileName) => {
        UserServerActionCreators.updateUser(initialUsers[profileName]);
      });
    }
    const currentUserNode = document.getElementById('current-user-data');
    if (currentUserNode) {
      const currentUser = JSON.parse(currentUserNode.textContent);
      UserServerActionCreators.setCurrentUser(currentUser);
    }
  },
};
